import axios from 'axios';
import BaseAPI from './base/base-api';

class SupplierOnlyDownInvAPI extends BaseAPI {
    constructor() {
        super();
        this.urlName = 'InvoiceBotsAPI';
        this.controllerName = 'supplieronlydowninv';
    }
}

export default new SupplierOnlyDownInvAPI();
